import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AuditorAvarageGradeProps = {
  avarageGrade?: number;
};

const AuditorAvarageGrade = ({ avarageGrade }: AuditorAvarageGradeProps) => {
  const { t } = useTranslation();

  return (
    <Typography variant="h6">
      {t('Avarage grade', { defaultValue: 'Avarage grade' })}: {avarageGrade}
    </Typography>
  );
};

export default AuditorAvarageGrade;
